import * as React from "react";
const SvgMicrosoftOutlook = (props) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "60 90.4 570.02 539.67", ...props }, /* @__PURE__ */ React.createElement("defs", null, /* @__PURE__ */ React.createElement("linearGradient", { id: "microsoft-outlook_a", x1: 9.989, x2: 30.932, y1: 22.365, y2: 9.375, gradientTransform: "scale(15)", gradientUnits: "userSpaceOnUse" }, /* @__PURE__ */ React.createElement("stop", { offset: 0, style: {
  stopColor: "#20a7fa",
  stopOpacity: 1
} }), /* @__PURE__ */ React.createElement("stop", { offset: 0.4, style: {
  stopColor: "#3bd5ff",
  stopOpacity: 1
} }), /* @__PURE__ */ React.createElement("stop", { offset: 1, style: {
  stopColor: "#c4b0ff",
  stopOpacity: 1
} })), /* @__PURE__ */ React.createElement("linearGradient", { id: "microsoft-outlook_b", x1: 17.197, x2: 28.856, y1: 26.794, y2: 8.126, gradientTransform: "scale(15)", gradientUnits: "userSpaceOnUse" }, /* @__PURE__ */ React.createElement("stop", { offset: 0, style: {
  stopColor: "#165ad9",
  stopOpacity: 1
} }), /* @__PURE__ */ React.createElement("stop", { offset: 0.501, style: {
  stopColor: "#1880e5",
  stopOpacity: 1
} }), /* @__PURE__ */ React.createElement("stop", { offset: 1, style: {
  stopColor: "#8587ff",
  stopOpacity: 1
} })), /* @__PURE__ */ React.createElement("linearGradient", { id: "microsoft-outlook_c", x1: 25.701, x2: 12.756, y1: 27.048, y2: 16.501, gradientTransform: "scale(15)", gradientUnits: "userSpaceOnUse" }, /* @__PURE__ */ React.createElement("stop", { offset: 0.237, style: {
  stopColor: "#448aff",
  stopOpacity: 0
} }), /* @__PURE__ */ React.createElement("stop", { offset: 0.792, style: {
  stopColor: "#0032b1",
  stopOpacity: 0.2
} })), /* @__PURE__ */ React.createElement("linearGradient", { id: "microsoft-outlook_d", x1: 24.053, x2: 44.51, y1: 31.11, y2: 18.018, gradientTransform: "scale(15)", gradientUnits: "userSpaceOnUse" }, /* @__PURE__ */ React.createElement("stop", { offset: 0, style: {
  stopColor: "#1a43a6",
  stopOpacity: 1
} }), /* @__PURE__ */ React.createElement("stop", { offset: 0.492, style: {
  stopColor: "#2052cb",
  stopOpacity: 1
} }), /* @__PURE__ */ React.createElement("stop", { offset: 1, style: {
  stopColor: "#5f20cb",
  stopOpacity: 1
} })), /* @__PURE__ */ React.createElement("linearGradient", { id: "microsoft-outlook_e", x1: 29.828, x2: 17.397, y1: 30.327, y2: 19.571, gradientTransform: "scale(15)", gradientUnits: "userSpaceOnUse" }, /* @__PURE__ */ React.createElement("stop", { offset: 0, style: {
  stopColor: "#0045b9",
  stopOpacity: 0
} }), /* @__PURE__ */ React.createElement("stop", { offset: 0.67, style: {
  stopColor: "#0d1f69",
  stopOpacity: 0.2
} })), /* @__PURE__ */ React.createElement("linearGradient", { id: "microsoft-outlook_g", x1: 41.998, x2: 23.852, y1: 29.943, y2: 29.943, gradientTransform: "scale(15)", gradientUnits: "userSpaceOnUse" }, /* @__PURE__ */ React.createElement("stop", { offset: 0, style: {
  stopColor: "#4dc4ff",
  stopOpacity: 1
} }), /* @__PURE__ */ React.createElement("stop", { offset: 0.196, style: {
  stopColor: "#0fafff",
  stopOpacity: 1
} })), /* @__PURE__ */ React.createElement("linearGradient", { id: "microsoft-outlook_k", x1: 3.458, x2: 20.929, y1: 37.872, y2: 37.86, gradientTransform: "scale(15)", gradientUnits: "userSpaceOnUse" }, /* @__PURE__ */ React.createElement("stop", { offset: 0.206, style: {
  stopColor: "#6ce0ff",
  stopOpacity: 1
} }), /* @__PURE__ */ React.createElement("stop", { offset: 0.535, style: {
  stopColor: "#50d5ff",
  stopOpacity: 0
} })), /* @__PURE__ */ React.createElement("radialGradient", { id: "microsoft-outlook_f", cx: 0, cy: 0, r: 1, fx: 0, fy: 0, gradientTransform: "matrix(0 -405.04051 438.393 0 360.027 102.268)", gradientUnits: "userSpaceOnUse" }, /* @__PURE__ */ React.createElement("stop", { offset: 0.568, style: {
  stopColor: "#275ff0",
  stopOpacity: 0
} }), /* @__PURE__ */ React.createElement("stop", { offset: 0.992, style: {
  stopColor: "#002177",
  stopOpacity: 1
} })), /* @__PURE__ */ React.createElement("radialGradient", { id: "microsoft-outlook_h", cx: 0, cy: 0, r: 1, fx: 0, fy: 0, gradientTransform: "scale(173.58) rotate(-45 5.168 -1.292)", gradientUnits: "userSpaceOnUse" }, /* @__PURE__ */ React.createElement("stop", { offset: 0.259, style: {
  stopColor: "#0060d1",
  stopOpacity: 0.4
} }), /* @__PURE__ */ React.createElement("stop", { offset: 0.908, style: {
  stopColor: "#0383f1",
  stopOpacity: 0
} })), /* @__PURE__ */ React.createElement("radialGradient", { id: "microsoft-outlook_i", cx: 0, cy: 0, r: 1, fx: 0, fy: 0, gradientTransform: "matrix(357.40702 -468.44593 423.59457 323.18709 159.471 697.08)", gradientUnits: "userSpaceOnUse" }, /* @__PURE__ */ React.createElement("stop", { offset: 0.732, style: {
  stopColor: "#f4a7f7",
  stopOpacity: 0
} }), /* @__PURE__ */ React.createElement("stop", { offset: 1, style: {
  stopColor: "#f4a7f7",
  stopOpacity: 0.501961
} })), /* @__PURE__ */ React.createElement("radialGradient", { id: "microsoft-outlook_j", cx: 0, cy: 0, r: 1, fx: 0, fy: 0, gradientTransform: "matrix(-170.86087 259.7254 -674.01813 -443.40415 278.562 412.979)", gradientUnits: "userSpaceOnUse" }, /* @__PURE__ */ React.createElement("stop", { offset: 0, style: {
  stopColor: "#49deff",
  stopOpacity: 1
} }), /* @__PURE__ */ React.createElement("stop", { offset: 0.724, style: {
  stopColor: "#29c3ff",
  stopOpacity: 1
} })), /* @__PURE__ */ React.createElement("radialGradient", { id: "microsoft-outlook_l", cx: 0, cy: 0, r: 1, fx: 0, fy: 0, gradientTransform: "rotate(46.924 -378.504 245.25) scale(315.927)", gradientUnits: "userSpaceOnUse" }, /* @__PURE__ */ React.createElement("stop", { offset: 0.039, style: {
  stopColor: "#0091ff",
  stopOpacity: 1
} }), /* @__PURE__ */ React.createElement("stop", { offset: 0.919, style: {
  stopColor: "#183dad",
  stopOpacity: 1
} })), /* @__PURE__ */ React.createElement("radialGradient", { id: "microsoft-outlook_m", cx: 0, cy: 0, r: 1, fx: 0, fy: 0, gradientTransform: "matrix(0 168 -193.782 0 180 491.159)", gradientUnits: "userSpaceOnUse" }, /* @__PURE__ */ React.createElement("stop", { offset: 0.558, style: {
  stopColor: "#0fa5f7",
  stopOpacity: 0
} }), /* @__PURE__ */ React.createElement("stop", { offset: 1, style: {
  stopColor: "#74c6ff",
  stopOpacity: 0.501961
} }))), /* @__PURE__ */ React.createElement("path", { d: "m463.984 140.145-344.347 218.27-29.614-46.72v-40.257a43.26 43.26 0 0 1 19.72-36.293L309.91 105.258c30.496-19.79 69.777-19.793 100.277-.008Zm0 0", style: {
  stroke: "none",
  fillRule: "nonzero",
  fill: "url(#microsoft-outlook_a)"
} }), /* @__PURE__ */ React.createElement("path", { d: "M407.102 103.34a91.293 91.293 0 0 1 3.082 1.914l156.214 101.332-387.336 245.52-59.437-93.77L403.895 177.8c26.925-17.102 28.105-55.57 3.207-74.461Zm0 0", style: {
  stroke: "none",
  fillRule: "nonzero",
  fill: "url(#microsoft-outlook_b)"
} }), /* @__PURE__ */ React.createElement("path", { d: "M407.102 103.34a91.293 91.293 0 0 1 3.082 1.914l156.214 101.332-387.336 245.52-59.437-93.77L403.895 177.8c26.925-17.102 28.105-55.57 3.207-74.461Zm0 0", style: {
  stroke: "none",
  fillRule: "nonzero",
  fill: "url(#microsoft-outlook_c)"
} }), /* @__PURE__ */ React.createElement("path", { d: "M333.602 498.988 179.066 452.11 507.63 243.836c27.672-17.54 27.601-57.938-.133-75.379l-1.48-.93 4.261 2.649 99.996 64.867a43.263 43.263 0 0 1 19.723 36.3v38.962Zm0 0", style: {
  stroke: "none",
  fillRule: "nonzero",
  fill: "url(#microsoft-outlook_d)"
} }), /* @__PURE__ */ React.createElement("path", { d: "M333.602 498.988 179.066 452.11 507.63 243.836c27.672-17.54 27.601-57.938-.133-75.379l-1.48-.93 4.261 2.649 99.996 64.867a43.263 43.263 0 0 1 19.723 36.3v38.962Zm0 0", style: {
  stroke: "none",
  fillRule: "nonzero",
  fill: "url(#microsoft-outlook_e)"
} }), /* @__PURE__ */ React.createElement("path", { d: "M410.188 105.25c-30.5-19.785-69.782-19.781-100.282.008L109.742 235.145a43.26 43.26 0 0 0-19.719 36.292v1.97a44.479 44.479 0 0 0 20.735 36.16l248.887 156.91L609.16 309.805a44.468 44.468 0 0 0 20.824-37.664v38.168l.008-38.965c0-14.66-7.426-28.32-19.722-36.301Zm0 0", style: {
  stroke: "none",
  fillRule: "nonzero",
  fill: "url(#microsoft-outlook_f)"
} }), /* @__PURE__ */ React.createElement("path", { d: "M315.77 630.05h220.449c51.777 0 93.75-41.972 93.75-93.75V272.14c0 15.301-7.864 29.528-20.82 37.665l-327.907 205.89a60.712 60.712 0 0 0-28.422 51.414c.004 34.762 28.184 62.942 62.95 62.942Zm0 0", style: {
  stroke: "none",
  fillRule: "nonzero",
  fill: "url(#microsoft-outlook_g)"
} }), /* @__PURE__ */ React.createElement("path", { d: "M315.77 630.05h220.449c51.777 0 93.75-41.972 93.75-93.75V272.14c0 15.301-7.864 29.528-20.82 37.665l-327.907 205.89a60.712 60.712 0 0 0-28.422 51.414c.004 34.762 28.184 62.942 62.95 62.942Zm0 0", style: {
  stroke: "none",
  fillRule: "nonzero",
  fill: "url(#microsoft-outlook_h)"
} }), /* @__PURE__ */ React.createElement("path", { d: "M315.77 630.05h220.449c51.777 0 93.75-41.972 93.75-93.75V272.14c0 15.301-7.864 29.528-20.82 37.665l-327.907 205.89a60.712 60.712 0 0 0-28.422 51.414c.004 34.762 28.184 62.942 62.95 62.942Zm0 0", style: {
  stroke: "none",
  fillRule: "nonzero",
  fill: "url(#microsoft-outlook_i)"
} }), /* @__PURE__ */ React.createElement("path", { d: "M405.402 630.035H183.738c-51.777 0-93.75-41.972-93.75-93.75v-264.34a44.473 44.473 0 0 0 20.754 37.621l327.582 206.52a61.737 61.737 0 0 1 28.809 52.226c-.004 34.09-27.64 61.723-61.73 61.723Zm0 0", style: {
  stroke: "none",
  fillRule: "nonzero",
  fill: "url(#microsoft-outlook_j)"
} }), /* @__PURE__ */ React.createElement("path", { d: "M405.402 630.035H183.738c-51.777 0-93.75-41.972-93.75-93.75v-264.34a44.473 44.473 0 0 0 20.754 37.621l327.582 206.52a61.737 61.737 0 0 1 28.809 52.226c-.004 34.09-27.64 61.723-61.73 61.723Zm0 0", style: {
  stroke: "none",
  fillRule: "nonzero",
  fill: "url(#microsoft-outlook_k)"
} }), /* @__PURE__ */ React.createElement("path", { d: "M108.75 345h142.5c26.926 0 48.75 21.824 48.75 48.75v142.5c0 26.926-21.824 48.75-48.75 48.75h-142.5C81.824 585 60 563.176 60 536.25v-142.5C60 366.824 81.824 345 108.75 345Zm0 0", style: {
  stroke: "none",
  fillRule: "nonzero",
  fill: "url(#microsoft-outlook_l)"
} }), /* @__PURE__ */ React.createElement("path", { d: "M108.75 345h142.5c26.926 0 48.75 21.824 48.75 48.75v142.5c0 26.926-21.824 48.75-48.75 48.75h-142.5C81.824 585 60 563.176 60 536.25v-142.5C60 366.824 81.824 345 108.75 345Zm0 0", style: {
  stroke: "none",
  fillRule: "nonzero",
  fill: "url(#microsoft-outlook_m)"
} }), /* @__PURE__ */ React.createElement("path", { d: "M179.387 534c-19.848 0-36.137-6.21-48.875-18.625-12.739-12.414-19.11-28.617-19.11-48.605 0-21.11 6.465-38.18 19.395-51.22C143.73 402.517 160.66 396 181.594 396c19.781 0 35.879 6.238 48.297 18.715 12.484 12.476 18.726 28.93 18.726 49.351 0 20.985-6.469 37.899-19.398 50.75C216.352 527.606 199.742 534 179.387 534Zm.574-26.352c10.816 0 19.523-3.695 26.117-11.082 6.594-7.386 9.89-17.664 9.89-30.824 0-13.719-3.202-24.394-9.6-32.031-6.403-7.637-14.95-11.453-25.638-11.453-11.011 0-19.878 3.941-26.597 11.824-6.723 7.824-10.082 18.191-10.082 31.102 0 13.101 3.36 23.468 10.082 31.101 6.719 7.574 15.328 11.363 25.828 11.363Zm0 0", style: {
  stroke: "none",
  fillRule: "nonzero",
  fill: "#fff",
  fillOpacity: 1
} }), /* @__PURE__ */ React.createElement("path", { d: "M179.332 535.848c-19.77 0-36-6.375-48.691-19.13-12.688-12.753-19.036-29.398-19.036-49.929 0-21.684 6.442-39.219 19.325-52.61 12.882-13.394 29.75-20.09 50.601-20.09 19.703 0 35.742 6.411 48.114 19.227 12.437 12.82 18.652 29.72 18.652 50.7 0 21.55-6.442 38.93-19.32 52.129-12.82 13.136-29.368 19.703-49.645 19.703Zm.57-27.067c10.778 0 19.453-3.797 26.02-11.383 6.57-7.59 9.851-18.144 9.851-31.664 0-14.093-3.187-25.058-9.562-32.902-6.379-7.844-14.89-11.766-25.54-11.766-10.972 0-19.804 4.047-26.5 12.149-6.694 8.031-10.042 18.683-10.042 31.945 0 13.457 3.348 24.106 10.043 31.95 6.695 7.78 15.273 11.671 25.73 11.671Zm0 0", style: {
  stroke: "none",
  fillRule: "nonzero",
  fill: "#fff",
  fillOpacity: 1
} }));
export default SvgMicrosoftOutlook;
